import React,{useContext} from 'react';
import {SITE_TITLE, GetRedirectUrl} from '../../settings/common';
import { AppContext } from '../../helpers/AppContext';

const Footer= () => {
	const path = GetRedirectUrl();
	const {isSidebarHidden, setSidebarHidden } = useContext(AppContext);

    return (
        <React.Fragment>
			{(path !== 'login') && (
				<React.Fragment>
					<footer className={`${isSidebarHidden ? 'sb-hide':''}`}>
						<div className="copyright">
							<p><span id="copyright_year">2024</span> © Babysoft, All rights Reserved.</p>
							<p>Design by Babysoft.</p>
						</div>
					</footer>
				</React.Fragment>
			)}
			
		</React.Fragment>
		
    );
};

export default Footer;